import { initExploreGroups } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/explore/groups/index.js?vue3';

initExploreGroups();
